import apiUrl from '../../../../../utils/settings';

export const gapDetailsUrl = () => apiUrl + '/benefits-v2/cumulative-gap';
export const DownloadNpsTransactionStatementUrl = () => {
  return apiUrl + '/benefits-v2/nps-transaction-statement';
};